import {
  TextField, TextFieldProps, Switch, FormControlLabel, FormControlLabelProps, Autocomplete,
} from '@mui/material';
import { useField } from 'formik';
import TagSelect from './TagSelect';

export function FormikTextField({ name, ...props }: { name: string } & Omit<TextFieldProps, 'name'>) {
  const [field, meta] = useField(name);
  return (
    <TextField
      {...field}
      {...props}
      value={field.value ?? ''}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error ? meta.error : props.helperText}
    />
  );
}

export interface SelectOption { value: string; label: string }

export function FormikSelect({ name, label, options, helperText }: {
  name: string; label: string; options: readonly SelectOption[]; helperText?: string;
}) {
  const [field, meta, helpers] = useField<string>(name);
  return (
    <Autocomplete
      size="small"
      options={options}
      getOptionLabel={(o) => o.label}
      value={options.find(o => o.value === field.value) ?? options[0]}
      onChange={(_, v) => helpers.setValue(v.value)}
      disableClearable
      isOptionEqualToValue={(o, v) => o.value === v.value}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          size="small"
          error={meta.touched && !!meta.error}
          helperText={meta.touched && meta.error ? meta.error : helperText}
        />
      )}
    />
  );
}

export function FormikTagSelect({ name }: { name: string }) {
  const [field, , helpers] = useField<string[]>(name);
  return <TagSelect value={field.value ?? []} onChange={(ids) => helpers.setValue(ids)} />;
}

export function FormikSwitch({
  name,
  label,
  ...props
}: { name: string; label: string } & Omit<FormControlLabelProps, 'control' | 'label' | 'name'>) {
  const [field, , helpers] = useField(name);
  return (
    <FormControlLabel
      {...props}
      control={
        <Switch
          checked={!!field.value}
          onChange={(e) => helpers.setValue(e.target.checked)}
        />
      }
      label={label}
    />
  );
}
